export default __webpack_public_path__ + "static/nail-salon-logo-4f9da0c5d31313731162371e6eb8254b.svg";